import { ReactElement } from 'react'
import { shallowEqual, useDispatch, useSelector } from 'react-redux'
import {
  DropdownWrapper,
  EditableDropdown,
  Input,
  PageWrapper
} from '../../../../../components'
import strings from '../../../../../locale/en'
import { RootState } from '../../../../../redux/store'
import { updateStudentInformation } from '../../../../../redux/userDetail/actions'
import { boardList, mediumList } from './const'
import { FlexWrapper, InfoWrapper } from './subcomponents'

const QualifyingExamDetails = (): ReactElement => {
  const {
    studentInformation: {
      regNo,
      statNo,
      lastAttended,
      yearOfPassing,
      markObtained,
      percentage
    }
  } = useSelector(
    (state: RootState) => ({
      studentInformation: state.userDetail.studentInformation
    }),
    shallowEqual
  )
  const dispatch = useDispatch()

  const {
    studentDetails: {
      mediumLabel,
      mediumPlaceholder,
      previousExamLabel,
      previousExamPlaceholder,
      satsNoLabel,
      satsPlaceholder,
      boardLabel,
      boardPlaceholder,
      schoolLabel,
      schoolPlaceholder,
      yearOfPassingLabel,
      yearOfPassingPlaceholder,
      obtainMarksLabel,
      obtainMarksPlaceholder,
      percentagePlaceholder,
      percentagelabel
    }
  } = strings

  return (
    <PageWrapper>
      <InfoWrapper>
        <FlexWrapper width="100%">
          <DropdownWrapper>
            <EditableDropdown
              dropdownList={mediumList}
              title={mediumLabel}
              placeholder={mediumPlaceholder}
              handleSelect={({ name }) =>
                dispatch(updateStudentInformation({ medium: name }))
              }
            />
          </DropdownWrapper>
          <DropdownWrapper>
            <EditableDropdown
              dropdownList={boardList}
              title={boardLabel}
              placeholder={boardPlaceholder}
              onBlur={() => {}}
              error={''}
              handleSelect={({ name }) =>
                dispatch(updateStudentInformation({ board: name }))
              }
            />
          </DropdownWrapper>
          <DropdownWrapper>
            <Input
              label={schoolLabel}
              placeholder={schoolPlaceholder}
              value={lastAttended || ''}
              onBlur={() => {}}
              error={''}
              width="100%"
              onChange={(value: string) => {
                dispatch(updateStudentInformation({ lastAttended: value }))
              }}
              height="50px"
            />
          </DropdownWrapper>
          <DropdownWrapper>
            <Input
              label={previousExamLabel}
              placeholder={previousExamPlaceholder}
              value={regNo || ''}
              width="100%"
              onChange={(value: string) => {
                dispatch(updateStudentInformation({ regNo: value }))
              }}
              height="50px"
            />
          </DropdownWrapper>
          <DropdownWrapper>
            <Input
              label={yearOfPassingLabel}
              placeholder={yearOfPassingPlaceholder}
              value={yearOfPassing || ''}
              onBlur={() => {}}
              error={''}
              width="100%"
              onChange={(value: string) => {
                dispatch(updateStudentInformation({ yearOfPassing: value }))
              }}
              height="50px"
            />
          </DropdownWrapper>
          <DropdownWrapper>
            <Input
              label={satsNoLabel}
              placeholder={satsPlaceholder}
              value={statNo || ''}
              onBlur={() => {}}
              error={''}
              width="100%"
              onChange={(value: string) => {
                dispatch(updateStudentInformation({ statNo: value }))
              }}
              height="50px"
            />
          </DropdownWrapper>
          <DropdownWrapper>
            <Input
              label={obtainMarksLabel}
              placeholder={obtainMarksPlaceholder}
              value={markObtained || ''}
              onBlur={() => {}}
              error={''}
              width="100%"
              onChange={(value: string) => {
                dispatch(updateStudentInformation({ markObtained: value }))
              }}
              height="50px"
            />
          </DropdownWrapper>
          <DropdownWrapper>
            <Input
              label={percentagelabel}
              placeholder={percentagePlaceholder}
              value={percentage || ''}
              onBlur={() => {}}
              error={''}
              width="100%"
              onChange={(value: string) => {
                dispatch(updateStudentInformation({ percentage: value }))
              }}
              height="50px"
            />
          </DropdownWrapper>
        </FlexWrapper>
      </InfoWrapper>
    </PageWrapper>
  )
}

export default QualifyingExamDetails
